
import CommercialCart from "./CommercialCart/CommercialCart";
import ExpandValidity from "./ExpandValidity/ExpandValidity";
import PanelComerciales from "./PanelComerciales/PanelComerciales";

export const configFile = [
    {
        tab: 'tab-1',
        tag: 'span',
        title: 'Expandir Vigencia',
        Contents: ExpandValidity,
    },
    {
        tab: 'tab-2',
        tag: 'span',
        title: 'Retencion de usuarios',
        Contents: ExpandValidity,
    },
    {
        tab: 'tab-3',
        tag: 'span',
        title: 'Carrito Comercial',
        Contents: CommercialCart,
    },
    {
        tab: 'tab-4',
        tag: 'span',
        title: 'Panel Comerciales',
        Contents: PanelComerciales,
    },
];

